<script setup lang="ts">
import {computed} from "vue";
import CrossFilterRenderer from "@/components/bi/CrossFilterRenderer.ts";
import DTOFilledQuestionField = namaTypes.DTOFilledQuestionField;
import QuestionField = namaTypes.QuestionField;

const props = defineProps<{
  filledQuestion: DTOFilledQuestionField;
  questionField?: QuestionField;
}>();

defineEmits<{
  remove: []
}>();

const renderedValue = computed(() => CrossFilterRenderer.renderValue(props.filledQuestion, props.questionField));
const chipIcon = computed(() => CrossFilterRenderer.iconForType(props.questionField?.fieldType));
const tooltipText = computed(() => {
  const label = CrossFilterRenderer.renderLabel(props.questionField);
  const value = renderedValue.value;
  return label ? `${label}: ${value}` : value;
});
</script>

<template>
  <q-chip dense removable size="sm" color="primary" text-color="white"
          :icon="chipIcon"
          :title="tooltipText"
          @remove="$emit('remove')">
    {{ renderedValue }}
  </q-chip>
</template>
